<template>
  <v-textarea
    :value="value"
    :label="field.label"
    placeholder=" "
    :readonly="readOnly || disabled"
    outlined
    hide-details
    dense
    persistentPlaceholder
    :background-color="readOnly || disabled ? '' : 'white'"
    @blur="changeValue"
  />
</template>

<script>
  export default {
    name: "InputTextArea",
    props: {
      field: Object,
      value: String,
      readOnly: Boolean,
      disabled: Boolean,
    },
    model: {
      prop: "value",
      event: "change",
    },
    methods: {
      changeValue(evn) {
        if (evn?.target) {
          return this.$emit("change", evn.target.value);
        }

        this.$emit("change", evn);
      },
    },
  };
</script>

<style lang="scss" scoped></style>
